/**
 * Lines are drawn and left out in turn along their length, see StripePattern.
 */
export type Stripe = {
  /** Index of the pattern. */
  pattern: number;
  /** Each length of the pattern is multiplied by it. */
  scale: number;
  /** How far along the scaled pattern the line starts. */
  offset: number;
};

/**
 * Lengths that alternate between drawn and left out, starting with drawn.
 * A drawn length of 0 is a dot.
 */
export type StripePattern = number[];

/**
 * Whether the stripe is drawn at the distance d along the line.
 */
export function isStripeDrawnAt(stripe: Stripe, pattern: StripePattern, d: number): boolean {
  const total = pattern.reduce((sum, length) => sum + length, 0) * stripe.scale;

  if (total <= 0) {
    return true;
  }

  const u = (((stripe.offset + d) % total) + total) % total;
  let start = 0;

  for (let i = 0; i < pattern.length; i++) {
    const length = pattern[i] * stripe.scale;

    if (i % 2 === 0 && u >= start && u < start + length) {
      return true;
    }

    start += length;
  }

  return false;
}
